module.exports = __webpack_public_path__ + "media/images/phone-call-ff282789f8b9241c30a1bb28368bac87.png";